import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { PatFormData } from 'components/Assessments/PatAssessment/types/PatFormData'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAppointmentTimeWithTimezone } from 'components/Assessments/helpers'
import { convertAppointmentTimeFormDataToFlatAnswers } from 'components/Assessments/helpers.uncontrolled'
import { AssessmentOverviewFormField } from './formField'
import { AssessmentOverviewQuestionnaireItem } from './questionnaire'

/**
 * Assessment Overview subsection adapter for PAT Assessment
 * Handles appointment time extraction and transformation
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<PatFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<PatFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Extract appointment time with timezone support
    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options?.caregiverTimezone
    )

    return {
      [AssessmentOverviewFormField.APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    // Build appointment time mutations
    if (this.formDataFieldExists(AssessmentOverviewFormField.APPOINTMENT_TIME)) {
      const appointmentTime = this.getFormDataField(AssessmentOverviewFormField.APPOINTMENT_TIME)
      if (appointmentTime) {
        const { appointmentTimeValues } =
          convertAppointmentTimeFormDataToFlatAnswers(appointmentTime)
        mutations.push(
          {
            linkId: AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
            value: appointmentTimeValues.at(0)
          },
          {
            linkId: AssessmentOverviewQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
            value: appointmentTimeValues.at(1)
          }
        )
      }
    }

    return mutations
  }
}
